import { Banknote, CalendarDays, ChevronLeft, MapPin, Sun } from "lucide-react";

const statusList = [
  {
    label: "Job Reference",
    value: "JO-ABC123",
  },
  {
    label: "Applied On",
    value: "26 Mar 2026",
  },
  {
    label: "Job Type",
    value: "Full Time",
  },
  {
    label: "Industry",
    value: "Finance",
  },
  {
    label: "Experience level",
    value: "Mid Level",
  },
  {
    label: "Salary Range",
    value: "60,000 - 80,000",
  },
  {
    label: "Location",
    value: "London, UK",
  },
];

const CurrentStatus = () => {
  return (
    <div className="flex flex-col border rounded-md p-3 gap-5">
      <div className="flex items-center justify-between">
        <span className="font-bold text-xss">Current status</span>
        <div className="font-semibold text-xss bg-blue-50 rounded-md flex items-center justify-center text-blue-700 px-2 py-1">
          Interview Scheduled
        </div>
      </div>

      <div className="flex flex-col bg-blue-50 rounded-md p-2 gap-3">
        <div className="flex gap-2">
          <CalendarDays size={14} />
          <div className="flex flex-col gap-1">
            <span className="font-bold text-xss text-charcoal">
              Upcoming Interview
            </span>
            <span className="font-bold text-xss text-charcoal">
              Fri 18 Mar 2026 4:00 PM
            </span>
          </div>
        </div>
        <div className="flex gap-2 items-center">
          <MapPin size={14} />
          <span className="font-bold text-xss text-charcoal">
            123 High Street, London
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {statusList?.map((status) => {
          return (
            <div className="grid grid-cols-[0.4fr_0.6fr] gap-3">
              <span className="font-semibold text-xss text-slate-600">
                {status?.label}
              </span>
              <span className="font-semibold text-xss">{status?.value}</span>
            </div>
          );
        })}
      </div>

      <div className="flex bg-red-50 p-3 rounded-md gap-2">
        <Sun size={15} />
        <div className="flex flex-col gap-1">
          <span className="text-xs font-bold">You're doing great!</span>
          <span className="text-xsss font-semibold text-blue-900">You've made it to the interview stage.</span>
          <span className="text-xsss font-semibold text-blue-900">Prepare well and wish you the best of luck!</span>
        </div>
      </div>
    </div>
  );
};

export default CurrentStatus;
